import { DayPickerButtonProps } from "@/components/Inputs/RangePicker/components/DayPickerButton/DayPickerButtonProps.ts";
import { locales } from "@/helpers/locales.ts";
import { isThisYear } from "date-fns";
import format from "date-fns/format";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

export const DayPickerButton = (props: DayPickerButtonProps) => {
  const { t } = useTranslation();
  const locale = locales[i18n.language];

  const renderDate = (date: Date | null) => {
    if (!date) return t("select");
    const isSmall = window.innerWidth <= 480;
    if (isThisYear(new Date(date))) {
      return format(new Date(date), isSmall ? "iii dd.MM." : "iiii dd.MM.", { locale });
    } else {
      if (window.innerWidth < 768) {
        return format(new Date(date), "iii dd.MM.yyyy", { locale });
      }
      return format(new Date(date), "iiii dd.MM.yyyy", { locale });
    }
  };

  return (
    <div
      className={`${props.disabled ? "daypicker-show" : "daypicker-show-enabled"}`}
      onClick={() => !props.disabled && props.setHideDatePicker((prev) => !prev)}
    >
      {props.prefixIcon}
      <div className="daypicker-show_date">
        <span>Check In</span>
        <span>{renderDate(props.startDate)}</span>
      </div>
      <div className="daypicker-show_date">
        <span>Check Out</span>
        <span>{renderDate(props.endDate)}</span>
      </div>
    </div>
  );
};
